'use client';

import React from 'react';
import type { HeadlineProps } from '@/ui';
import { Box, Typography } from '@/ui';
import type { MarginType } from '@/ui/utils/spacing';
import styles from './HeadlineSeparator.module.css';

export interface HeadlineSeparatorProps {
  id?: string;
  separatorTitle?: React.ReactNode;
  title: React.ReactNode;
  level?: HeadlineProps['level'];
  marginTop?: MarginType;
}

export const HeadlineSeparator: React.FC<HeadlineSeparatorProps> = ({
  id,
  separatorTitle,
  title,
  level = 2,
  marginTop = 160,
}) => (
  <Box marginTop={marginTop} marginBottom={40}>
    <Box marginBottom={12}>
      {separatorTitle && (
        <Typography.Caption size="L" opacity={0.25} textAlign="center">
          <span className={styles.separator}>{separatorTitle}</span>
        </Typography.Caption>
      )}
    </Box>

    <Typography.Headline id={id} marginTop={0} level={level} textAlign="center">
      <Typography.Base>{title}</Typography.Base>
    </Typography.Headline>
  </Box>
);
